let db = null;
let dbReadyPromise = null;
const isValidKey = (key) => {
    if (key === undefined || key === null) return false;
    if (typeof key === 'string' || typeof key === 'number') return true;
    if (key instanceof Date) return true;
    if (Array.isArray(key)) {
        return key.length > 0 && key.every((k) => typeof k === 'string' || typeof k === 'number' || k instanceof Date);
    }
    return false;
};
// 初始化数据库（保证在使用前已就绪）
const initDB = () => {
    if (db && db.close) {
        return Promise.resolve(db);
    }
    if (dbReadyPromise) {
        return dbReadyPromise;
    }
    dbReadyPromise = new Promise((resolve, reject) => {
        const request = indexedDB.open('teaHouse', 1);

        request.onupgradeneeded = function (e) {
            const database = e.target.result;
            if (!database.objectStoreNames.contains('teaHouse')) {
                database.createObjectStore('teaHouse', { keyPath: 'msg' });
            }
        };

        request.onsuccess = function (e) {
            db = e.target.result;
            db.onclose = function () {
                console.log('数据库关闭');
            };
            resolve(db);
        };

        request.onerror = function () {
            console.log('数据库打开失败');
            reject(new Error('数据库打开失败'));
        };

        request.onblocked = function () {
            console.warn('数据库升级被阻塞，请关闭其他标签页后重试');
        };
    });
    return dbReadyPromise;
};
// 添加数据
export const addData = async (data) => {
    const database = db || (await initDB());
    if (!data || typeof data !== 'object') {
        return Promise.reject(new Error('数据无效：需为对象'));
    }
    if (!isValidKey(data.msg)) {
        return Promise.reject(new Error('键无效：data.msg 需为字符串/数字/日期/非空数组'));
    }
    return new Promise((resolve, reject) => {
        const transaction = database.transaction(['teaHouse'], 'readwrite');
        const store = transaction.objectStore('teaHouse');
        const request = store.add(data);
        request.onsuccess = function (e) {
            resolve(e.target.result);
        };
        request.onerror = function (e) {
            reject(e.target.error);
        };
    });
};
// 获取数据
export const getData = async (msg) => {
    const database = db || (await initDB());
    console.log(msg);
    if (!isValidKey(msg)) {
        return Promise.reject(new Error('键无效：msg 需为字符串/数字/日期/非空数组'));
    }
    return new Promise((resolve, reject) => {
        const transaction = database.transaction(['teaHouse'], 'readonly');
        const store = transaction.objectStore('teaHouse');
        const request = store.get(msg);
        request.onsuccess = function (e) {
            resolve(e.target.result);
        };
        request.onerror = function (e) {
            reject(e.target.error);
        };
    });
};
// 提前触发初始化（可选）
initDB();
